import { component } from 'picoapp'
import $ from '../lib/quantdom'
import { post } from '../lib/ajax'

export default component((node) => {
  const productId = $(node).attr('data-product-id')
  const data = {
    methods: [
      {
        method: 'main_widget',
        params: {
          pid: productId,
          page: '1',
        },
        format: 'html',
      },
    ],
    app_key: 'nTfom57rHljn6x8qn35bk7J9KqzjGq5iiMVg1Rbk',
    is_mobile: false,
  }

  post('https://staticw2.yotpo.com/batch', data).then((res) => {
    const html = res[0].result
    $(node).html(html)
    yotpo.widgets = [yotpo.widgets.find((el) => el.analyticsCategory == 'reviews')]
    const yotpoAapi = new Yotpo.API(yotpo)
    yotpoAapi.refreshWidgets()
  })
})
